import parse from 'html-react-parser'
import React, { useEffect, useState } from 'react'

import styles from './projectDescription.module.scss'
import { ProjectDescriptionTypes } from './ProjectDescription.types'

export const ProjectDescription = ({ text }: ProjectDescriptionTypes) => {
  const [openText, setOpenText] = useState<boolean>(false)
  const handleOpenText = () => {
    setOpenText(!openText)
  }

  useEffect(() => {
    setOpenText(false)
  }, [text])

  return (
    <div className={styles.descriptionWrapper}>
      <h2 className={styles.descriptionTitle}>О проекте</h2>
      <div
        className={styles.descriptionTextBlock}
        style={{
          height: openText ? 'auto' : '0',
          WebkitLineClamp: openText ? 'inherit' : '',
        }}
      >
        <p className={styles.descriptionText}>{parse(text)}</p>
      </div>
      <button className={styles.descriptionBtn} onClick={handleOpenText}>
        {openText ? 'Свернуть' : 'Читать далее'}
      </button>
    </div>
  )
}
